import { Component, Inject, OnDestroy, OnInit, AfterViewInit, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { OrganisationDataService, Organisation, IOrganisation, IOrganisationsHierarchy } from '@services/organisation-data.service';
import { AuthService } from '@auth0/auth0-angular';
import { DOCUMENT, formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { GlobalFunctions, imagePath, imgTypes } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { distinctUntilChanged, filter, finalize, takeUntil } from 'rxjs/operators';
import { combineLatest, firstValueFrom, Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Account, AccountFeatures, AccountsService, IAccount } from '@services/accounts.service';
import { AuthenticationService, IWebAppUser } from '@services/authentication.service';
import { MatSidenav } from '@angular/material/sidenav';
import { FormControl } from '@angular/forms';
import { SidebarComponent } from '@syncfusion/ej2-angular-navigations';
import { IAccountInviteDetail, InvitesService } from '@services/invites.service';
import { UpdateService } from '@services/update-service.service';
import { NotificationService, NotificationType, SystemMessageTypes } from '@services/notifications.service';
import { isExpired } from '@functions/functions';

/**
 * Navigation Button Interface
 */
interface NavButton {
	label: string;
	iconClass?: string;          // CSS class or icon identifier
	iconOutlined?: boolean;          // CSS class or icon identifier
	imgSrc?: string;         // optional, for custom images instead of <mat-icon>
	route?: string;         // route name if using gotoRoute()
	clickFn?: () => void;   // optional function for direct clicks
	tooltip?: string;
	featureFlag?: AccountFeatures;   // optional feature flag
	dividerAfter?: boolean; // optional divider after this button
	menu?: string; // optional for matMenuTriggerFor
	accountAdmin?: boolean //optional is an admin button
}

/**
 * Default Class
 */
@Component({
	selector: 'app-home-navigation',
	templateUrl: './home-navigation.component-ejs.html',
	styleUrls: ['./home-navigation.component-ejs.scss']
})
export class HomeNavigationComponent implements OnInit, OnDestroy, AfterViewInit {

	public isExpired = isExpired

	/** Path to Accounts Images */
	public imagePathAccounts(accountGUID?: string): string {
		return imagePath(accountGUID, imgTypes.accounts).toLowerCase()
	}

	private GotoNewDashboard: boolean = false;

	/** Get AccountFeatures Enum */
	AccountFeatures = AccountFeatures;

	/** Side Nav Bar */
	@ViewChild(MatSidenav) sidenav: MatSidenav;

	/** Collection of the Subscription Objects for this Component */
	private subscriptions: Map<string, Subscription> = new Map();

	/** Environment Variables */
	public env: any;

	/** Close Result */
	public closeResult = '';

	/** Application Name */
	public sAppName: string;

	/** Organisations List Form */
	public frmOrganisationList = new FormControl

	/** Organisations Array*/
	public Organisations: Organisation[] = [];

	/** Organisations JSON */
	public OrganisationJSON: string = "";

	/** Selected Organisations JSON */
	public selectedOrganisationJSON: string = "";

	/** Organisations Structure */
	public OrganisationStructure: IOrganisationsHierarchy[];

	/** Selected Organisation */
	public selectedOrganisation: IOrganisation;

	/** Selected Organisation ID */
	public selectedOrganisationUID: string = "";

	/** Accounts Array*/
	public Accounts: Account[] = [];

	/** Accounts JSON */
	public AccountsJSON: string = "";

	/** Selected Account */
	public selectedAccount: Account

	/** Selected Account GUID */
	public selectedAccountGUID: string = ""

	/** selected Location */
	public selectedLocation: string = "";

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** loggedOnUser */
	public thisUser: IWebAppUser;

	/** isSmallScreen */
	public isSmallScreen = false;

	/** isMobile */
	public isMobile: boolean = false;

	/** HostListener */
	@HostListener('window:resize', ['$event'])
	onResize(event: any) { this.adjustPadding(); }

	private skipNextAccountGUID: boolean = false;
	private skipNextOrganisationUID: boolean = false;

	@ViewChild('dockBar')
	public dockBar: SidebarComponent;
	public dockBarMode: string = "Push"
	public enableDock: boolean = true;
	public dockIsOpen = false;

	@ViewChild('sidebarTreeviewInstance')
	public sidebarTreeviewInstance: SidebarComponent;
	public width: string = '20em';
	public target: string = '.main-sidebar-content';
	public mediaQuery: string = '(min-width: 600px)';

	public myInvites: IAccountInviteDetail[] = [];

	/** hostName */
	public hostName: string = "";

	/** Navigation Buttons */
	navButtons: NavButton[] = [];
	/** Admin Buttons */
	adminButtons: NavButton[] = [];

	/** updateAvailable */
	public updateAvailable: boolean = false;

	/** expired */
	public selectedAccountExpired: boolean = false;

	/** expiredMessage */
	public expiredMessage: string = "";

	/**
	 * Default Constructor
	 * @param updateService updateService
	 * @param auth auth
	 * @param observer BreakpointObserver,
	 * @param organisationDataService organisationDataService
	 * @param authenticationService AuthenticationService,
	 * @param globalFunctions globalFunctions
	 * @param router router
	 * @param siteSubscriptions siteSubscriptions
	 * @param document document
	 * @param breakpointObserver breakpoint Observer
	 * @param inviteService inviteService
	 * @param cdr cdr
	 * @param notificationService notificationService
	 */
	constructor(
		public updateService: UpdateService,
		public auth: AuthService,
		private observer: BreakpointObserver,
		private organisationDataService: OrganisationDataService,
		private authenticationService: AuthenticationService,
		private globalFunctions: GlobalFunctions,
		private router: Router,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private breakpointObserver: BreakpointObserver,
		private inviteService: InvitesService,
		private cdr: ChangeDetectorRef,
		private notificationService: NotificationService
	) {

		this.updateService.updateAvailable$.subscribe(flag => {
			// console.log(`${this.constructor.name} => this.updateService.updateAvailable$.subscribe`)
			this.updateAvailable = flag;
		});

		// Monitor for small screen size changes		
		this.breakpointObserver.observe([
			Breakpoints.XSmall,
			Breakpoints.Small
		]).subscribe(result => {
			this.isSmallScreen = result.matches;
		});

		this.env = environment

		this.hostName = window.location.hostname;

		let subscription = undefined

		// Unsubscribe from existing subscription to this specific observable if it exists
		this.unsubscribeFromObservable("currentUser$");
		subscription = this.authenticationService.currentUser$.pipe(
			takeUntil(this.finalise), distinctUntilChanged(),
			filter(thisUser => !!thisUser)
		).subscribe({
			next: (thisUser: IWebAppUser) => {
				try {
					if (thisUser) {
						this.thisUser = thisUser;

						if (this.dockBar && this.dockBar.element && this.dockBar.element.classList.contains("e-hidden")) {
							this.dockBar.element.classList.remove("e-hidden");
						}

						this.SubscribeAccounts()
						this.SubscribeOrganisations()
						this.subscribeSelectedStructure()
						this.subscribeInvitations(thisUser.Email)

					}
				} catch (error) { console.error(error); }
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: auth.user$", false)
			},
			// complete: () => { console.log("auth.user$.subscribe: Complete"); }
		});
		this.subscriptions.set('currentUser$', subscription);
	}

	/**
	 * Unsubscribe when needed (for example, in ngOnDestroy lifecycle hook)
	 */
	ngOnDestroy() {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
			this.unsubscribeFromAll()
		}
		catch { }
	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {
		this.isMobile = this.checkIfMobile();
	}

	/**
	 * Page after view init Event Handler
	 */
	ngAfterViewInit(): void {


		// Ensure that the layout adjustment occurs after a small delay
		setTimeout(() => {
			//this.setupSideNav()
			window.dispatchEvent(new Event('resize'));
		}, 500); // Adjust the delay (300ms) as necessary to fit your layout rendering time
	}

	/**
	 * checkIfMobile
	 * @returns
	 */
	checkIfMobile(): boolean {
		return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
	}

	/**
	 * toolbarCliked
	 * @param args
	 */
	// toolbarCliked(args: ClickEventArgs) {
	// 	if (args.item.tooltipText == "Menu") {
	// 		this.dockBar.toggle();
	// 	}
	// }
	toolbarCliked(): void {
		this.sidebarTreeviewInstance.toggle();
	}

	/**
	 * adjustContent
	 */
	adjustContent() {
		// // Ensure that the layout adjustment occurs after a small delay
		// setTimeout(() => {
		// 	//this.setupSideNav()
		// 	window.dispatchEvent(new Event('resize'));
		// }, 300); // Adjust the delay (300ms) as necessary to fit your layout rendering time
		// this.cdr.detectChanges();

		//redraw dashboards if they are open
		this.siteSubscriptions.RedrawDashboard(true);
	}

	/**
	 * setupSideNav
	 */
	setupSideNav() {
		this.observer.observe(['(max-width: 600px)']).pipe(
			takeUntil(this.finalise), distinctUntilChanged()
		).subscribe(
			(res) => {
				// if (this.sidenav) {
				// 	if (res.matches) {
				// 		this.sidenav.mode = 'over';
				// 		if (this.sidenav.opened) { this.sidenav.close(); }
				// 	} else {
				// 		this.sidenav.mode = 'side';
				// 		if (!this.sidenav.opened) { this.sidenav.open(); }
				// 	}
				// }

				// try {
				// 	if (this.dockBar) {
				// 		if (res.matches) {
				// 			this.dockBarMode = "over"
				// 			if (this.dockBar.isOpen) { this.dockBar.toggle(); }
				// 		} else {
				// 			this.dockBarMode = "side"
				// 			if (!this.dockBar.isOpen) { this.dockBar.toggle(); }
				// 		}
				// 	}
				// }
				// catch (error) {
				// 	console.error(error);
				// }
			});

		// Unsubscribe from existing subscription to this specific observable if it exists
		// this.unsubscribeFromObservable("router.events");
		// const subscription = this.router.events
		// 	.pipe(filter((e) => e instanceof NavigationEnd))
		// 	.subscribe(() => {
		// 		// if (this.sidenav.mode === 'over' && this.sidenav.opened) { this.sidenav.close(); }
		// 		if (this.dockBarMode === 'over' && this.dockBar.isOpen) { this.dockBar.toggle(); }

		// 	});
		// this.subscriptions.set('router.events', subscription);
		// this.adjustPadding();
	}

	/**
	 * adjustPadding
	 */
	adjustPadding(): void {
		const fixedBottom = document.getElementById('fixed-bottom');
		const content = document.getElementById('content')
		if (fixedBottom && content) {
			content.style.paddingBottom = fixedBottom.clientHeight + 'px';
		}
	}

	/**
	 * Subscribe to Accounts
	 */
	SubscribeAccounts() {
		try {
			combineLatest([
				this.siteSubscriptions.myAccounts$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
				this.siteSubscriptions.selectedAccountGUID$.pipe(takeUntil(this.finalise), distinctUntilChanged())
			]).pipe(
				// Ensure that subscriptions are not null or undefined
				filter(([myAccounts, selectedAccountGUID]) => !!myAccounts && !this.skipNextAccountGUID)
			).subscribe({
				next: ([myAccounts, selectedAccountGUID]) => {
					try {
						this.skipNextAccountGUID = true;
						/** Refresh the Accounts list */
						this.Accounts = this.siteSubscriptions.normalizeFeatures(myAccounts) as Account[];

						/** Validate we have an Account GUID if not then use Users Default Account*/
						if (selectedAccountGUID == "") { selectedAccountGUID = this.thisUser.DefaultAccount; }
						/** Check this account is in our list */
						let FindAccount = <IAccount>this.Accounts.find(({ GUID }) => GUID.toUpperCase() === selectedAccountGUID.toUpperCase());
						/** Ignore if not changed */
						if (this.selectedAccountGUID != selectedAccountGUID) {

							/** Account does appear in Users Accounts */
							this.selectedAccount = FindAccount ?? this.Accounts[0];
							this.selectedAccountGUID = this.selectedAccount.GUID;

							this.selectedAccountExpired = isExpired(this.selectedAccount.Expiry);
							if (this.selectedAccountExpired) {
								this.expiredMessage = `${this.selectedAccount.Name} Account Expired on ${formatDate(this.selectedAccount.Expiry, 'dd-MMM-yyyy', 'en-GB')}`;
								// this.notificationService.postSystem(this.selectedAccountGUID, SystemMessageTypes.AccountExpired, this.expiredMessage, false, false);
							}

							this.skipNextAccountGUID = true;
							this.siteSubscriptions.SetSelectedAccount(this.selectedAccount)
							this.siteSubscriptions.SetSelectedAccountGUID(this.selectedAccountGUID)

							if (this.selectedAccount && this.selectedAccount.GUID != "") {
								this.siteSubscriptions.RefreshMyOrganisations(this.selectedAccount.GUID)
							}

							/** Do we need to go somewhere? */
							let targetURL = localStorage.getItem("targetURL");
							if (targetURL) {
								localStorage.removeItem("targetURL");
								this.router.navigateByUrl(targetURL);
							}

						} else { this.selectedAccount = FindAccount; }
					}
					catch (error) { console.error(error); } finally { this.skipNextAccountGUID = false; }
				},
				error: (error) => { this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false); }
			});
		} catch (error) { console.error(error); }

	}

	/**
	 * Subscribe to the OrganisationList
	 */
	SubscribeOrganisations() {
		let Update: boolean = false

		try {
			// Unsubscribe from existing subscription to this specific observable if it exists
			// this.unsubscribeFromObservable("myOrganisations$");
			combineLatest([
				this.siteSubscriptions.myOrganisations$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
				this.siteSubscriptions.selectedOrganisationUID$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			]).pipe(
				// Ensure that subscriptions are not null or undefined
				// && !!selectedOrganisationJSON && !!selectedOrganisationUID
				filter(([myOrganisations, selectedOrganisationUID]) => !!myOrganisations && !this.skipNextOrganisationUID)
			).subscribe({
				next: async ([myOrganisations, selectedOrganisationUID]) => {
					try {
						this.skipNextOrganisationUID = true;
						/** Check that the Organisations have changed */
						if (this.OrganisationJSON != JSON.stringify(myOrganisations)) {
							this.OrganisationJSON = JSON.stringify(myOrganisations);
							this.Organisations = myOrganisations;
							/** Reset the selected Organisation */
							this.selectedOrganisationUID = "";
							this.selectedOrganisationJSON = "";
							this.selectedOrganisation = <IOrganisation>{};
						}

						/** selected Organisation Changed and Valid */
						try {
							if (this.selectedOrganisationUID != selectedOrganisationUID && selectedOrganisationUID != "") {
								this.selectedOrganisation = <Organisation>this.Organisations.find(({ Uid }) => Uid.toUpperCase() === selectedOrganisationUID.toUpperCase());
								this.selectedOrganisationUID = this.selectedOrganisation.Uid
								Update = true;
							}
						} catch (error) {
							this.selectedOrganisationUID = ""
						}

						if (this.selectedOrganisationUID == "") {
							this.selectedOrganisation = this.Organisations[0];
							this.selectedOrganisationUID = this.selectedOrganisation.Uid
							Update = true;
						}

						if (Update) {
							if (this.selectedAccount) { this.BuildNavigationButtons(); }
							/** Update the Selected Account Subscription */
							this.siteSubscriptions.SetSelectedOrganisation(this.selectedOrganisation);
							this.siteSubscriptions.SetSelectedOrganisationUID(this.selectedOrganisationUID);
							/** Subscribe to this Structure */
							await this.getOrganisationStructure(this.selectedAccountGUID, this.selectedOrganisationUID)

							if (this.GotoNewDashboard) {
								this.gotoDashboard(this.selectedAccountGUID, this.selectedOrganisationUID)
							}
						}
					} catch (error) { console.error(error); } finally {
						this.skipNextOrganisationUID = false;
						this.GotoNewDashboard = false;
					}
				},
				error: (error) => {
					this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
				}
			});

		} catch (error) { console.error(error); }
	}


	/**
	 * BuildNavigationButtons
	 */
	BuildNavigationButtons() {
		let orgName = this.selectedOrganisation.Name || "Organisation"

		this.navButtons = [
			{
				label: `${orgName} Dashboard`,
				iconClass: 'home',
				clickFn: () => this.gotoDashboard(this.selectedAccountGUID, this.selectedOrganisationUID),
				tooltip: `${orgName} Dashboard`
			},
			// {
			// 	label: 'Energy Dashboard',
			// 	iconClass: 'energy-dashboard',
			// 	iconOutlined: true,
			// 	clickFn: () => this.gotoEnergyDashboard(),
			// 	tooltip: `${orgName} Energy Dashboard`,
			// 	featureFlag: features.Energy_Dashboard
			// },			
			{
				label: 'Flagged Assets',
				iconClass: 'flagged',
				route: 'flagged',
				tooltip: `${orgName} Flagged Assets`,
				dividerAfter: true
			},
			{
				label: 'Functional Locations',
				iconClass: 'location',
				route: 'location',
				tooltip: `${orgName} Locations`
			},
			{
				label: 'Events',
				iconClass: 'notifications',
				route: 'event',
				tooltip: `${orgName} Events`
			},
			{
				label: 'Rules',
				iconClass: 'rules',
				route: 'rules',
				tooltip: `${orgName} Rules`
			},
			{
				label: 'Models',
				iconClass: 'models',
				route: 'models',
				tooltip: `${orgName} Models`
			},
			{
				label: 'Watch List',
				iconClass: 'visibility',
				route: 'watch',
				tooltip: `${orgName} Watch List`,
				featureFlag: AccountFeatures.Watch_List
			},
			{
				label: 'Actions',
				iconClass: 'actions',
				route: 'actions',
				tooltip: `${orgName} Actions`,
				featureFlag: AccountFeatures.Actions
			},
			{
				label: 'Compare Assets',
				iconClass: 'compare',
				route: 'compare',
				tooltip: `Compare ${orgName} Assets`,
				featureFlag: AccountFeatures.Compare_Assets
			},
			{
				label: 'Utility Reporting',
				iconClass: 'reporting',
				clickFn: () => this.goToEnergyReporting(),
				tooltip: `${orgName} Utility Reporting`,
				featureFlag: AccountFeatures.Energy_Monitoring
			},
			{
				label: 'SAP Cases',
				iconClass: 'sapCases',
				route: 'SAPCases',
				tooltip: `SAP Cases for ${orgName}`,
				featureFlag: AccountFeatures.SAP
			}
		];

		this.adminButtons = [
			{
				label: 'Management Settings',
				iconClass: 'settings',
				tooltip: 'Management Settings',
				menu: "settingsMenu",
				accountAdmin: true
			},
			{
				label: 'Support',
				iconClass: 'contact-support',
				tooltip: 'Support',
				menu: "supportMenu" // 
			}
		];

	}

	/**
	 * subscribeInvitations
	 */
	subscribeInvitations(userUmail: string = "") {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		let invitedUsers = []
		let data = {
			"publicUID": this.thisUser.Sub,
			"accountGUID": "",
			"inviteGUID": "",
			"inviteEmail": userUmail,
			"ShowAll": true
		}
		this.inviteService.getInvitations$(data).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((invites) => !!invites),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (invites) => {
				invitedUsers = <IAccountInviteDetail[]>invites
				this.myInvites = <IAccountInviteDetail[]>invitedUsers.filter(
					({ InviteEmail, Accepted, Canceled }) => InviteEmail.toLowerCase() == this.thisUser.Email.toLowerCase() && Accepted == false && Canceled == false
				);
			},
			error: (error) => {
				if (error.status = 404) {
					// console.log("No Invitations");
				} else {
					// console.error("this.inviteService.getInvitations$:", error)
				}
			},
			//complete: () => { console.log("this.inviteService.getInvitations$: Complete"); }
		});
	}

	/**
	 * Select an Account
	 * @param accountUID value
	 */
	async SelectAccount(accountUID: string) {
		try {
			if (this.selectedAccountGUID != accountUID) {
				this.GotoNewDashboard = true;
				/** Load the new Selected Account */
				this.siteSubscriptions.SetSelectedAccountGUID(accountUID, false);

				// /** Refresh the list of Organisations for the new Account */
				// var OrgList = await this.siteSubscriptions.RefreshMyOrganisations(accountUID);

				// /** Navigate to the Dashboard */
				// this.gotoDashboard(accountUID, OrgList[0].Uid);
			}
		} catch (error) { console.error(error); }
	}


	// /**
	//  * OrganisationChange
	//  * @param event
	//  */
	// OrganisationChange(event: any) {
	// 	/** Prevent reloading if value not changed */
	// 	if (this.selectedOrganisationUID != "" && this.selectedOrganisationUID.toUpperCase() != this.selectedOrganisation.Uid.toUpperCase()) {
	// 		this.SelectOrganisation(this.selectedOrganisationUID);
	// 	};
	// }

	/**
	 * Select an Organisation
	 * @param organisationUID value
	 */
	SelectOrganisation(organisationUID: string) {
		try {
			if (this.selectedOrganisationUID != organisationUID) {
				this.GotoNewDashboard = true;
				this.siteSubscriptions.SetSelectedOrganisationUID(organisationUID);
				//this.siteSubscriptions.SetSelectedSubLocation(value);
				/** Navigate to the Dashboard */
				// this.gotoDashboard(this.selectedAccountGUID, organisationUID)
			}
		} catch (error) { console.error(error); }
	}

	/**
	 * Get the Organisation Structure
	 * @param AccountID AccountID
	 * @param OrganisationID OrganisationID
	 */
	async getOrganisationStructure(AccountID: string, OrganisationUID: string) {

		try {

			const structure = await firstValueFrom(
				this.organisationDataService.getOrganisationStructure$(AccountID, OrganisationUID).pipe(
					filter((structure) => !!structure)
				)
			);

			/** Update the Organisation */
			this.OrganisationStructure = JSON.parse(structure);
			this.siteSubscriptions.SethierarchicalData(this.OrganisationStructure);

			// // Create a local Subject to control the subscription lifecycle
			// const fetchDataSubject = new Subject<void>();

			// /** Get the Organisation for the selection */
			// this.organisationDataService.getOrganisationStructure$(AccountID, OrganisationUID).pipe(
			// 	takeUntil(fetchDataSubject), distinctUntilChanged(),
			// 	filter((structure) => !!structure),
			// 	finalize(() => {
			// 		// Ensure the subscription is terminated and the subject is completed
			// 		fetchDataSubject.next();
			// 		fetchDataSubject.complete();
			// 	})
			// ).subscribe({
			// 	next: (structure: any) => {
			// 		try {
			// 			/** Update the Organisation */
			// 			this.OrganisationStructure = JSON.parse(structure);
			// 			this.siteSubscriptions.SethierarchicalData(this.OrganisationStructure);
			// 		} catch (error) { console.error(error); }
			// 	},
			// 	error: (error) => {
			// 		if (error["status"] != 404) {
			// 			this.globalFunctions.HandleError(error, "Error: organisationDataService.getOrganisationStructure$(OrganisationUID).subscribe$", false)
			// 		}
			// 	},
			// 	//complete: () => { console.log("organisationDataService.getOrganisationStructure$(OrganisationUID).subscribe: Complete"); }
			// });
		} catch (error: any) {
			// console.error(error); 
			if (error["status"] != 404) {
				this.globalFunctions.HandleError(error, "Error: this.organisationDataService.getOrganisationStructure$", false)
			}
		}
	}

	/**
	 * Subscribe to Structure
	 */
	subscribeSelectedStructure() {
		try {

			/** Get the Structure for the selection Location */
			// Unsubscribe from existing subscription to this specific observable if it exists
			this.unsubscribeFromObservable("selectedSubLocation$");
			const subscription = this.siteSubscriptions.selectedSubLocation$.pipe(
				takeUntil(this.finalise), distinctUntilChanged()
			).subscribe({
				next: (folder: string) => {
					if (folder && folder != "") {
						this.selectedLocation = folder;
					}
				},
				error: (error) => { this.globalFunctions.HandleError(error, "Error: this.siteSubscriptions.selectedOrganisationUID$", false) },
				//complete: () => { console.log("this.siteSubscriptions.selectedSubFolder$.subscribe: Complete"); }
			});
			this.subscriptions.set('selectedSubLocation$', subscription);
		} catch (error) { console.error(error); }
	}

	/**
	 * gotoRoute
	 * @param target
	 */
	gotoRoute(target: string, url: string = "") {

		try {
			// Navigate to selected URL if provided
			if (url != "") {
				if (target == "email") {
					window.open(url, "_self");  // _self so it behaves like a normal link
					return;
				} else if (target == "github") {
					window.open(url, "_blank");  // Open in a new tab/browser window
					return;
				} else if (url.startsWith("http://") || url.startsWith("https://")) {
					window.open(url, "_blank");
					return;
				}
			}


			if (!this.selectedLocation || this.selectedLocation == "") {
				/** Do Nothing */
			} else {

				if (target == "location") {
					// this.router.navigate([`./organisations/${this.selectedOrganisationUID}/location/${this.selectedLocation}/${target}`]);
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/location/${this.selectedLocation}`]);
				}

				if (target == "assets") {
					// this.router.navigate([`./organisations/${this.selectedOrganisationUID}/location/${this.selectedLocation}/${target}`]);
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/assets`]);
				}

				if (target == "event") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/event`]);
				}

				if (target == "rules") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/rules`]);
				}

				if (target == "models") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/models`]);
				}

				if (target == "watch") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/watch`]);
				}

				if (target == "favourites") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/favourites`]);
				}

				if (target == "flagged") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/flagged`]);
				}

				if (target == "actions") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/actions`]);
				}

				if (target == "compare") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/compare`]);
				}

				if (target == "SAPCases") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/SAPCases`]);
				}

				if (target == "virtualSensors") {
					this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/virtualSensors`]);
				}
			}
		} catch (error) { console.error(error); }
	}

	/**
	 * gotoDashboard
	 * @returns
	 */
	gotoDashboard(accountGUID: string, OrganisationUID: string) {
		try {
			if (!this.selectedLocation || this.selectedLocation == "") {
				/** Do Nothing */
			} else {
				this.router.navigate([`./${accountGUID}/organisation/${OrganisationUID}/dashboard`]);
				// this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/dashboard`]);
			}
		} catch (error) { console.error(error); }
	}

	/**
	 * gotoEnergyDashboard
	 * @returns
	 */
	gotoEnergyDashboard() {
		try {
			if (!this.selectedLocation || this.selectedLocation == "") {
				/** Do Nothing */
			} else {
				this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/energy-dashboard`]);
			}
		} catch (error) { console.error(error); }
	}

	/**
	 * goToEnergyReporting
	 * @returns
	 */
	goToEnergyReporting() {
		try {
			if (!this.selectedLocation || this.selectedLocation == "") {
				/** Do Nothing */
			} else {
				this.router.navigate([`./${this.selectedAccountGUID}/organisation/${this.selectedOrganisationUID}/utility-reporting`]);
			}
		} catch (error) { console.error(error); }
	}

	/**
	 * Method to unsubscribe from a specific observable by key
	 */
	private unsubscribeFromObservable(key: string) {
		try {
			const subscription = this.subscriptions.get(key);
			if (subscription) {
				subscription.unsubscribe();
				this.subscriptions.delete(key);
			}
		} catch (error) { }
	}

	/**
	 * Method to unsubscribe from all subscriptions
	 */
	unsubscribeFromAll() {
		try {
			this.subscriptions.forEach(subscription => subscription.unsubscribe());
			this.subscriptions.clear();
			this.notificationService.cleanAccountNotifications(this.selectedAccountGUID)
		} catch (error) { }
	}

	/**
	 * goToHierarchyManagement
	 */
	goToHierarchyManagement() {
		let url = this.router.url;
		let currentLocation = "";
		if (url.includes("location")) {
			currentLocation = url.split("location")[1].split("/")[1];
		}
		this.router.navigate([`/setup/heirarchy-management/${this.selectedOrganisationUID}`], currentLocation ? {
			queryParams: { selectedLocation: currentLocation }
		} : {})
	}

	/**
	 * checkFeature
	 * @param feature feature   
	 * @returns 
	 */
	checkFeature(feature: AccountFeatures): boolean {
		if (this.selectedAccount && this.selectedAccount.Features) {
			return AccountsService.checkFeature(feature, this.selectedAccount)
		}
		return false;
	}

	/**
	 * goToDataModelManagement
	 */
	goToDataModelManagement() {
		this.router.navigate([`/setup/data-model-management/${this.selectedOrganisationUID}`]);
	}

	/**
	 * goToDashboardManagement
	 */
	goToDashboardManagement() {
		this.router.navigate([`/setup/dashboard-management/${this.selectedOrganisationUID}`]);
	}

	get issueEmailLink(): string {

		function getPlatformFromUserAgent(): string {
			const ua = navigator.userAgent;

			if (/Windows NT/i.test(ua)) return "Windows";
			if (/Macintosh/i.test(ua)) return "macOS";
			if (/Linux/i.test(ua)) return "Linux";
			if (/Android/i.test(ua)) return "Android";
			if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";

			return "Unknown";
		}
		// const to = 'prismpdm.support@malonegroup.com';
		const to = '"PRISMPdM Support" <prismpdm.support@malonegroup.com>';
		const subject = encodeURIComponent('PRISMPdM Issue Report');

		// Extract environment info
		const userAgent = navigator.userAgent;
		const platform = getPlatformFromUserAgent();
		const screenSize = `${window.screen.width}x${window.screen.height}`;
		const windowSize = `${window.innerWidth}x${window.innerHeight}`;
		const language = navigator.language;
		const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		const isMobile = /Mobi|Android/i.test(userAgent);
		const deviceType = isMobile ? 'Mobile' : 'Desktop';

		const body = encodeURIComponent(
			`Hi Support,

I encountered an issue with the PRISMPdM platform.

Description:
[Please describe the issue here]

---------------------------------------------------------------------
Details:
- Page: ${window.location.href}
- User: ${this.thisUser?.Name || 'Unknown'}
- Email: ${this.thisUser?.Email || 'Unknown'}

Environment:
- Device Type: ${deviceType}
- Platform: ${platform}
- Language: ${language}
- Timezone: ${timezone}
- Screen Size: ${screenSize}
- Window Size: ${windowSize}
- Browser: ${userAgent}
---------------------------------------------------------------------

Thanks,
${this.thisUser?.Name || 'Unknown'}
${this.thisUser?.Sub || 'Unknown'}`
		);

		return `mailto:${to}?subject=${subject}&body=${body}`;
	}

	/** reload */
	reload() {
		this.updateService.activateUpdate();
	}

	/**
	 * Log Out back to original location
	 */
	logout() {
		// this.notificationService.cleanAccountNotifications(this.selectedAccountGUID);
		this.notificationService.clear();

		this.authenticationService.logout(document);
	}

	/**
	 * Log in
	 */
	logIn() {
		this.authenticationService.login();
	}

	testNotification() {

		let type: NotificationType = NotificationType.System;

		const message = window.prompt('Enter notification message:', 'Account has Expired');

		if (message === null) {
			return;
		}

		this.notificationService.postSystem(this.selectedAccountGUID, SystemMessageTypes.AccountExpired, message, true, false);

		// this.notificationService.push({
		// 	type: type,
		// 	id: generateGUID(),
		// 	timestamp: Date.now(),
		// 	message: message,
		// 	canSnooze: true,
		// 	canCancel: false,
		// });
	}

	testNotificationClear() {
		this.notificationService.clear();
	}
}

